<template>
  <div class="shell-page">
    <HeaderMain />

    <section class="legal-shell">
      <div class="glass-surface legal-card">
        <div class="section-heading">
          <span class="section-heading__eyebrow">Legal and trust</span>
          <h1 class="section-heading__title">Terminos y condiciones</h1>
          <p class="section-heading__text">
            Transparencia, seguridad y claridad para que la experiencia de compra se sienta confiable antes, durante y despues del evento.
          </p>
        </div>

        <div class="legal-card__content">
          <p>
            Estos terminos aplican a todas las versiones del sitio y aplicaciones de FOMOPLANES que contengan un enlace a este documento. Al visitar el sitio, registrarte o comprar entradas, aceptas quedar obligado por estas condiciones y por sus futuras actualizaciones.
          </p>
          <p>
            Los eventos publicados en FOMOPLANES son responsabilidad de sus organizadores. La plataforma se encarga de la comercializacion, promocion y exposicion digital de los accesos. Solo cuando un evento sea identificado expresamente como una experiencia propia o coorganizada por FOMOPLANES, existira participacion directa en la produccion.
          </p>
          <p>
            La informacion personal compartida por el usuario para registro, validacion y compra se utiliza exclusivamente para fines del servicio. No se almacenan datos de tarjetas de credito o debito en la plataforma y el usuario declara que la informacion entregada es autentica y correcta.
          </p>
          <p>
            El usuario es responsable de elegir correctamente fecha, funcion, localidad y cantidad de entradas. No existen cambios, devoluciones ni reembolsos por errores del comprador ni por fees de servicio ya aceptados durante la compra.
          </p>
          <p>
            En caso de cancelacion, reprogramacion o devoluciones, la responsabilidad principal recae en el organizador. FOMOPLANES podra colaborar con la gestion cuando exista autorizacion previa o un acuerdo formal con el promotor correspondiente.
          </p>
          <p>
            Cuando el usuario agregue el extra opcional Fomo Safe durante el checkout, dicho valor se cobra como un addon independiente dentro del mismo pago. Fomo Safe protege compras elegibles frente a imprevistos personales validables que impidan asistir y tambien frente a cancelacion oficial del evento, sin modificar el fee de servicio del organizador.
          </p>
          <p>
            Fomo Safe contempla imprevistos personales validables y cancelacion oficial del evento. No cubre reprogramacion, cambios de horario, cambios de venue, errores de compra, fees ya aceptados, decisiones operativas distintas de una cancelacion formal ni el valor del propio addon. Toda solicitud queda sujeta a revision documental y validacion interna de FOMOPLANES.
          </p>
          <p>
            FOMOPLANES puede invalidar boletos digitales cuando existan disputas, sospechas de fraude, contracargos o consumos irregulares. El usuario tambien acepta que su compra esta protegida por la legislacion ecuatoriana aplicable en materia de comercio electronico, defensa del consumidor y firma electronica.
          </p>
          <p>
            Las compras realizadas en la plataforma cuentan con garantias legales y con las protecciones adicionales propias de cada pasarela de pago. Toda controversia sera tratada bajo las leyes de la Republica del Ecuador ante la jurisdiccion ordinaria competente.
          </p>
          <p>
            Al continuar navegando o comprando en FOMOPLANES, aceptas tambien las politicas de privacidad vinculadas a los servicios de terceros integrados cuando corresponda.
          </p>
        </div>
      </div>
    </section>

    <FooterMain />
  </div>
</template>

<script>
import HeaderMain from '@/components/HeaderMain.vue'
import FooterMain from '@/components/FooterMain.vue'

export default {
  name: 'TermsView',

  components: {
    HeaderMain,
    FooterMain,
  },
}
</script>

<style>
</style>
